$(document).ready(function() {
    // Get URL parameters
    var urlParams = new URLSearchParams(window.location.search);
    
    // Check for filter parameters
    var isFeaturedPage = urlParams.has('featured');
    var selectedBrand = urlParams.get('brand');
    var isDiscountedPage = urlParams.has('discounted');
    var isBundlePage = urlParams.has('bundle');
    
    // Pre-select brand checkbox if we have a brand filter
    if (selectedBrand) {
        $('.field-filter').each(function() {
            if ($(this).data('filter-name') === 'brand' && $(this).data('filter-value') === selectedBrand) {
                $(this).prop('checked', true);
            }
        });
    }
    
    // Enhanced filter button with feedback
    $('#filter-toggle-btn').click(function() {
        $('#filter-sidebar').addClass('open');
        $('body').addClass('filter-open');
        
        // Add visual feedback
        $(this).addClass('active');
        
        // Prevent background scrolling when filter is open
        $('body').css('overflow', 'hidden');
    });

    $('.close-filter').click(function() {
        closeFilterSidebar();
    });
    
    // Function to close filter sidebar
    function closeFilterSidebar() {
        $('#filter-sidebar').removeClass('open');
        $('body').removeClass('filter-open');
        $('#filter-toggle-btn').removeClass('active');
        $('body').css('overflow', '');
    }

    // Close filter when clicking outside or pressing escape
    $(document).on('click keydown', function(event) {
        // Close on outside click
        if (event.type === 'click' && 
            !$(event.target).closest('#filter-sidebar, #filter-toggle-btn').length && 
            $('#filter-sidebar').hasClass('open')) {
            closeFilterSidebar();
        }
        
        // Close on Escape key
        if (event.type === 'keydown' && event.key === 'Escape' && $('#filter-sidebar').hasClass('open')) {
            closeFilterSidebar();
        }
    });
    
    // Add swipe to close functionality for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    
    document.getElementById('filter-sidebar').addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
    }, false);
    
    document.getElementById('filter-sidebar').addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    }, false);
    
    function handleSwipe() {
        if (touchEndX < touchStartX - 50) { // Swipe left
            closeFilterSidebar();
        }
    }

    // Handle brand filter checkbox changes
    $(document).on('change', '.field-filter[data-filter-name="brand"]', function() {
        var isChecked = $(this).prop('checked');
        var brandValue = $(this).data('filter-value');
        
        // Provide visual feedback
        if (isChecked) {
            $(this).closest('.filter-option').addClass('active-filter');
        } else {
            $(this).closest('.filter-option').removeClass('active-filter');
        }
        
        // Uncheck other brand checkboxes if this one is checked
        if (isChecked) {
            $('.field-filter[data-filter-name="brand"]').not(this).prop('checked', false);
            $('.field-filter[data-filter-name="brand"]').not(this).closest('.filter-option').removeClass('active-filter');
        }
        
        // If the URL has a brand parameter but we unchecked or changed the brand filter,
        // redirect to remove the brand parameter
        if (selectedBrand && (!isChecked || (isChecked && brandValue !== selectedBrand))) {
            var newUrl = new URL(window.location.href);
            newUrl.searchParams.delete('brand');
            
            // Preserve other parameters
            if (isFeaturedPage) {
                newUrl.searchParams.set('featured', '1');
            }
            
            if (isDiscountedPage) {
                newUrl.searchParams.set('discounted', '1');
            }
            
            if (isBundlePage) {
                newUrl.searchParams.set('bundle', '1');
            }
            
            var page = urlParams.get('page');
            if (page) {
                newUrl.searchParams.set('page', page);
            }
            
            // If a new brand was selected, add it to the URL
            if (isChecked) {
                newUrl.searchParams.set('brand', brandValue);
            }
            
            // Show loading indicator before redirecting
            showLoading();
            
            window.location.href = newUrl.toString();
            return; // Stop execution to allow redirect
        }
        
        // If we selected a brand and there's no brand in the URL,
        // redirect to add the brand parameter
        if (isChecked && !selectedBrand) {
            var newUrl = new URL(window.location.href);
            newUrl.searchParams.set('brand', brandValue);
            
            // Show loading indicator before redirecting
            showLoading();
            
            window.location.href = newUrl.toString();
            return; // Stop execution to allow redirect
        }
    });

    // Other filters (non-brand)
    $(document).on('change', '.field-filter:not([data-filter-name="brand"]), .attribute-filter', function() {
        // Visual feedback
        if ($(this).prop('checked')) {
            $(this).closest('.filter-option').addClass('active-filter');
        } else {
            $(this).closest('.filter-option').removeClass('active-filter');
        }
        
        // Apply filters with loading indicator
        showLoading();
        applyFilters();
    });
    
    // Function to show loading indicator
    function showLoading() {
        // If loading overlay doesn't exist, create it
        if ($('#loading-overlay').length === 0) {
            $('body').append('<div id="loading-overlay"><div class="spinner"></div></div>');
            
            // Add CSS for the loading overlay
            $('<style>')
                .prop('type', 'text/css')
                .html(`
                    #loading-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(255, 255, 255, 0.8);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 9999;
                    }
                    .spinner {
                        width: 40px;
                        height: 40px;
                        border: 4px solid rgba(0, 0, 0, 0.1);
                        border-radius: 50%;
                        border-top-color: #333;
                        animation: spin 0.8s linear infinite;
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `)
                .appendTo('head');
        } else {
            $('#loading-overlay').show();
        }
    }
    
    // Function to hide loading indicator
    function hideLoading() {
        $('#loading-overlay').hide();
    }
    
    // Function to apply filters via AJAX
    function applyFilters() {
        var field_filters = {};
        var attribute_filters = {};

        // Collect field filters
        $('.field-filter:checked').each(function() {
            var field = $(this).data('filter-name');
            var value = $(this).data('filter-value');
            if (!field_filters[field]) {
                field_filters[field] = [];
            }
            field_filters[field].push(value);
        });

        // Collect attribute filters
        $('.attribute-filter:checked').each(function() {
            var attribute = $(this).data('attribute-name');
            var value = $(this).data('attribute-value');
            if (!attribute_filters[attribute]) {
                attribute_filters[attribute] = [];
            }
            attribute_filters[attribute].push(value);
        });

        // Make AJAX request
        var ajaxData = {
            field_filters: JSON.stringify(field_filters),
            attribute_filters: JSON.stringify(attribute_filters)
        };
        
        // Add featured parameter if needed
        if (isFeaturedPage) {
            ajaxData.featured = 1;
        }
        
        // Add brand parameter if needed (from URL or newly selected)
        var brandFilter = field_filters.brand ? field_filters.brand[0] : null;
        if (brandFilter) {
            ajaxData.brand = brandFilter;
        } else if (selectedBrand) {
            ajaxData.brand = selectedBrand;
        }
        
        // Add discounted parameter if needed
        if (isDiscountedPage) {
            ajaxData.discounted = 1;
        }
        
        // Add bundle parameter if needed
        if (isBundlePage) {
            ajaxData.bundle = 1;
        }
        
        frappe.call({
            method: 'noctis_ecommerce.www.shop.index.filter_products',
            args: ajaxData,
            callback: function(response) {
                if (response.message) {
                    $('#product-grid').html(response.message.html);
                    
                    // Add animation to new products
                    animateProductItems();
                }
                
                // Hide loading indicator after products are loaded
                hideLoading();
                
                // Close filter sidebar on mobile after applying filters
                if (window.innerWidth < 768) {
                    closeFilterSidebar();
                }
            }
        });
    }
    
    // Function to animate product items when they appear
    function animateProductItems() {
        $('.product-item').each(function(index) {
            $(this).css({
                'opacity': '0',
                'transform': 'translateY(20px)'
            });
            
            // Staggered animation
            setTimeout(() => {
                $(this).css({
                    'transition': 'opacity 0.5s ease, transform 0.5s ease',
                    'opacity': '1',
                    'transform': 'translateY(0)'
                });
            }, 50 * index);
        });
    }
    
    // Initialize with animation
    animateProductItems();
    
    // Handle back button for filters - reapply active filter styles
    window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            // Page was loaded from cache (back button)
            $('.field-filter:checked, .attribute-filter:checked').each(function() {
                $(this).closest('.filter-option').addClass('active-filter');
            });
        }
    });
    
    // Add active filter count to button if filters are applied
    function updateFilterButtonCount() {
        const checkedFilters = $('.field-filter:checked, .attribute-filter:checked').length;
        const filterBtn = $('#filter-toggle-btn');
        
        if (checkedFilters > 0) {
            // If we already have a count indicator, update it
            if (filterBtn.find('.filter-count').length) {
                filterBtn.find('.filter-count').text(checkedFilters);
            } else {
                // Create new count indicator
                filterBtn.append(`<span class="filter-count">${checkedFilters}</span>`);
                
                // Add style for count badge if not already added
                if ($('#filter-count-style').length === 0) {
                    $('<style id="filter-count-style">')
                        .prop('type', 'text/css')
                        .html(`
                            .filter-count {
                                display: inline-flex;
                                align-items: center;
                                justify-content: center;
                                background-color: #333;
                                color: white;
                                border-radius: 50%;
                                width: 20px;
                                height: 20px;
                                font-size: 11px;
                                margin-left: 5px;
                            }
                        `)
                        .appendTo('head');
                }
            }
        } else {
            // No filters applied, remove the count
            filterBtn.find('.filter-count').remove();
        }
    }
    
    // Run initially and on any filter change
    updateFilterButtonCount();
    $(document).on('change', '.field-filter, .attribute-filter', updateFilterButtonCount);
});
